<template>
  <div class="coach-assignments" v-if="!!+observation_settings">
    <div class="block-header">
      <div class="md-title">{{ observationLabel }}</div>
      <div
        class="pager"
        v-if="($mq == 'large' || $mq == 'xlarge') && observations.length && observations.length > size"
      >
        <button
          class="pager-nav button-previous"
          @click="prevPage"
          :disabled="pageNumber === 0"
        >Previous
        </button>
        <button
          class="pager-nav button-next"
          @click="nextPage"
          :disabled="pageNumber >= pageCount-1"
        >Next
        </button>
      </div>
    </div>
    <div v-if="observations.length" class="assignments-cards observation-cards">
      <div class="md-layout md-layout-item" v-if="$mq == 'large' || $mq == 'xlarge'">
        <md-card
          class="assignments-item overflow md-layout-item observations-item"
          :key="index"
          v-for="(item, index) in paginatedData"
          md-with-hover
          @click.native="openObservation(item)"
          @keypress.native.enter="openObservation(item)"
          tabindex="0"
        >
          <md-card-content>
            <div
              class="assignment-due-date"
              v-if="item.date"
            >{{ $moment(item.date * 1000).format('MM/DD/YYYY') }} {{ item.time ? $moment.utc(item.time *
              1000).local().format('h:mm A') : ""}}
            </div>
            <div class="assignment-title">{{ item.title }}</div>
            <div class="assignment-coach" v-if="item.coach">{{ item.coach }}</div>
          </md-card-content>
        </md-card>
      </div>

      <carousel v-else :perPage="1" :navigationEnabled="true" :paginationEnabled="false">
        <slide
          :key="index"
          v-for="(item, index) in observations"
        >
          <md-card class="assignments-item observations-item md-layout-item overflow-hidden">
            <md-card-content>
              <div @click.stop.prevent="openObservation(item)">
                <div
                  class="assignment-due-date"
                  v-if="item.date"
                >{{ $moment(item.date * 1000).format('MM/DD/YYYY') }} {{ item.time ? $moment.utc(item.time *
                  1000).local().format('h:mm A') : ""}}
                </div>
                <div class="assignment-title">{{ item.title }}</div>
                <div class="assignment-coach" v-if="item.coach">{{ item.coach }}</div>
              </div>
            </md-card-content>
          </md-card>
        </slide>
      </carousel>
    </div>
    <div v-else class="assignments-cards">
      <div class="empty-text">Nothing submitted yet.</div>
    </div>
  </div>
</template>

<script>
  import {Carousel, Slide} from "vue-carousel";

  export default {
    name: "LearnerObservationList",
    components: {
      Carousel,
      Slide,
    },
    computed: {
      pageCount() {
        let l = this.observations.length,
          s = this.size;
        return Math.ceil(l / s);
      },
      paginatedData() {
        const start = this.pageNumber * this.size,
          end = start + this.size;
        let sorted = this.observations.slice(0);

        sorted.sort((a, b) => {
          let aDate = new Date(
            this.$moment(a.date * 1000).format("MM/DD/YYYY") +
            (a.time
              ? " " +
              this.$moment
              .utc(a.time * 1000)
              .local()
              .format("h:mm A")
              : "")
          );
          let bDate = new Date(
            this.$moment(b.date * 1000).format("MM/DD/YYYY") +
            (b.time
              ? " " +
              this.$moment
              .utc(b.time * 1000)
              .local()
              .format("h:mm A")
              : "")
          );
          if (aDate < bDate) {
            return 1;
          }
          if (aDate > bDate) {
            return -1;
          }
          return 0;
        });
        return sorted.slice(start, end);
      },
    },
    data() {
      return {
        pageNumber: 0,
        size: 3,
        observations: window.drupalSettings.controller.observations || [],
        observation_settings:
        window.drupalSettings.controller.observation_settings,
        observationLabel: window.drupalSettings.group_catch_config.labels.observation_label,
      };
    },
    mounted() {
    },
    methods: {
      openObservation(item) {
        window.location.href = "/observation-submission/" + item.id;
      },
      nextPage() {
        this.pageNumber++;
      },
      prevPage() {
        this.pageNumber--;
      },
    },
  };
</script>
